import { render, staticRenderFns } from "./ApprovalGlSelectionChange.vue?vue&type=template&id=be84e57c"
import script from "./ApprovalGlSelectionChange.vue?vue&type=script&lang=js"
export * from "./ApprovalGlSelectionChange.vue?vue&type=script&lang=js"
import style0 from "./ApprovalGlSelectionChange.vue?vue&type=style&index=0&id=be84e57c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports